<template>
  <div class="setting-wrapper">
    <h3>Settings</h3>
    <div class="setting-container d-flex">
      <div class="">
        <ul class="side-section-menu">
          <!--<li>
            <a href="#personal-info">
              <img src="../assets/images/suitcase-icon.svg" />Personal Information
            </a>
          </li>
          <li>
            <a href="#address-info">
              <img src="../assets/images/address-icon.svg" />Address
            </a>
          </li>
          <li>
            <a href="#password-info">
              <img src="../assets/images/shield.svg" />Password and security
            </a>
          </li> -->
          <li>
            <a href="#notify-info">
              <img src="../assets/images/bell-icon.svg" />Notifications
            </a>
          </li>
        </ul>
      </div>

      <div class="setting-wrap">
        <!-- Personal info -->
        <!--<div class="personal-info detail-card mb-4" id="personal-info">
          <div class="title-head">
            <h5 class="mb-0">Personal information</h5>
          </div>
          <div class="pad-4 pb-0">
            <h5 class="mb-3"><b>Profile picture</b></h5>
            <div class="d-flex align-items-center">
              <div class="profile-wrap">
                <div class="profile-default">TA</div>
                <div class="edit-img">
                  <img src="../assets/images/edit-img.svg" />
                </div>
              </div>
              <div class="ml-3">
                <div class="f-600">Profile Picture</div>
                <div class="">JPEG, PNG under 10MB</div>
              </div>
            </div>
            <div class="details-wrap">
              <h5 class="mb-1"><b>Details</b></h5>
              <div class="edit-icon">
                <img src="../assets/images/edit-icon.svg" />
                <span class="edit-txt">Edit</span>
              </div>
            </div>
            <div class="row detail-info w-100">
              <div class="col-lg-3 col-md-6 mb-3">
                <label for="">Full name</label>
                <div class="f-600">John J. Doe</div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3 personal-detail">
                <label for="">Date of birth</label>
                <div class="f-600">May 6th, 2004</div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3 personal-detail">
                <label for="">Contact number</label>
                <div class="f-600">+91 9123456789</div>
              </div>
              <div class="col-lg-3 col-md-6 mb-3 personal-detail">
                <label for="">Marital status</label>
                <div class="f-600">Single</div>
              </div>
            </div>
          </div>
        </div>-->
        <!-- Address info -->
        <!--<div class="personal-info detail-card mb-4" id="address-info">
          <div class="title-head">
            <h5 class="mb-0">Address</h5>
          </div>
          <div class="pad-4 pb-0">
            <div class="details-wrap">
              <h5 class="mb-0"><b>Primary Address</b></h5>
              <div class="edit-icon">
                <img src="../assets/images/edit-icon.svg" />
                <span class="edit-txt">Edit</span>
              </div>
            </div>
            <div class="row detail-info w-100">
              <div class="col-md-12 col-lg-6 col-xl mb-3">
                <label for="">Address-1</label>
                <div class="f-600">Johnson street - 03</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">Address-2</label>
                <div class="f-600">Jolly street - 03</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">City</label>
                <div class="f-600">Youngs town</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">Zip Code</label>
                <div class="f-600">19991</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">State</label>
                <div class="f-600">Ohio</div>
              </div>
            </div>
          </div>
          <div class="pad-4 pb-0">
            <div class="details-wrap">
              <h5 class="mb-0"><b>Other Address</b></h5>
              <div class="edit-icon">
                <img src="../assets/images/edit-icon.svg" />
                <span class="edit-txt">Edit</span>
              </div>
            </div>
            <div class="row detail-info w-100">
              <div class="col-md-12 col-lg-6 col-xl mb-3">
                <label for="">Address-1</label>
                <div class="f-600">Johnson street - 03</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">Address-2</label>
                <div class="f-600">Jolly street - 03</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">City</label>
                <div class="f-600">Youngs town</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">Zip Code</label>
                <div class="f-600">19991</div>
              </div>
              <div class="col-md-12 col-lg-6 col-xl mb-3 personal-detail">
                <label for="">State</label>
                <div class="f-600">Ohio</div>
              </div>
            </div>
          </div>
        </div>-->
        <!-- Password and security info -->
        <!--<div class="personal-info detail-card mb-4" id="password-info">
          <div class="title-head">
            <h5 class="mb-0">Password and security</h5>
          </div>
          <div class="pad-4 pb-0">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="details-wrap mt-0">
                  <h5 class="mb-0"><b>Email</b></h5>
                  <div class="edit-icon">
                    <img src="../assets/images/edit-icon.svg" />
                    <span class="edit-txt">Edit</span>
                  </div>
                </div>
                <div class="row detail-info">
                  <div class="col-md-6">
                    <label for="">Email</label>
                    <div class="">Manage your account email for invoices</div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="" class="lbl"></label>
                    <div class="word-brk f-600">joshrupanzal0321@gmail.com</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="details-wrap mt-0">
                  <h5 class="mb-0"><b>SSN</b></h5>
                  <div class="edit-icon">
                    <img src="../assets/images/edit-icon.svg" />
                    <span class="edit-txt">Edit</span>
                  </div>
                </div>
                <div class="row detail-info">
                  <div class="col-md-6">
                    <label for="">SSN</label>
                    <div class="">Manage your account email for invoices</div>
                  </div>
                  <div class="col-md-6">
                    <label for="" class="lbl"></label>
                    <div class="word-brk f-600">XXXXXXXX01</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pad-4">
            <div class="details-wrap mt-0">
              <h5 class="mb-0"><b>Change Password</b></h5>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-6 mb-3">
                <label for="" class="mb-1">Current Password</label>
                <input
                  type="password"
                  placeholder="Enter Current Password"
                  class="univ-input"
                />
              </div>
              <div class="col-lg-4 col-md-6 mb-3">
                <label for="" class="mb-1">New Password</label>
                <input
                  type="password"
                  placeholder="Enter New Password"
                  class="univ-input"
                />
              </div>
              <div class="col-lg-4 col-md-6 mb-3">
                <label for="" class="mb-1">Confirm New Password</label>
                <input
                  type="password"
                  placeholder="Enter New Password"
                  class="univ-input"
                />
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <button class="save-btn disable-btn">
                <img src="../assets/images/save-icon.svg" /><span class="ml-2">Save Password</span>
              </button>
            </div>
          </div>
        </div>-->
        <!-- Notification info -->
        <div class="personal-info detail-card mb-4" id="notify-info">
          <div class="title-head">
            <h5 class="mb-0">Notification</h5>
          </div>
          <div class="pad-4">
            <div class="row">
              <!-- Email notification -->
              <div class="col-lg-12 col-lg-6 col-md-12">
                <p class="mb-1 info-title">Email notification</p>
                <div class="mb-2 info-light">
                  Get email to find what’s going on and what you are missing when you are offline. You can turn the following on and off:
                </div>
                <div class="category-filter">
                  <select 
                    class="univ-input mb-3"
                    v-model="selectedCategoryId" 
                    @change="onCategoryChange"
                    :disabled="loadingCategories"
                  >
                    <option value="" hidden>Select Category</option>
                    <option 
                      v-for="category in categories" 
                      :key="category.id" 
                      :value="category.id"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                  <div v-if="loadingCategories" class="text-center mb-3">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading categories...</span>
                    </div>
                    <span class="ml-2">Loading categories...</span>
                  </div>                           
                  <div v-if="selectedCategory" class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class=""><b>{{ selectedCategory.name }}</b></div>
                    <div class="form-check form-switch-parent m-0 p-0">
                      <label class="switch m-0">
                        <input type="checkbox" 
                          v-model="selectedCategory.enabled"
                          @change="updateCategoryStatus"
                          :disabled="updatingCategoryStatus"
                        />
                        <span class="slider round slider-parent"></span>
                      </label>
                    </div>
                  </div>
                  <hr v-if="selectedCategory" class="mt-2">
                  <div v-if="updatingCategoryStatus" class="text-center mb-3">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Updating...</span>
                    </div>
                    <span class="ml-2">Updating category status...</span>
                  </div>
                  <div v-if="loadingSubCategories" class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <span class="ml-2">Loading subcategories...</span>
                  </div>
                  <div v-else-if="selectedCategory" class="category-list">
                    <div 
                      v-for="subCategory in subCategories" 
                      :key="subCategory.id"
                      class="d-flex gap-3 mb-3"
                    >
                      <div class="form-check form-switch m-0 p-0">
                        <label class="switch">
                          <input 
                            type="checkbox" 
                            v-model="subCategory.enabled"
                            @change="updateSubCategoryStatus(subCategory)"
                            :disabled="updatingSubCategoryStatus"
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                      <div>
                        <h3 class="h6 mb-1">{{ subCategory.name }}</h3>
                        <p class="text-muted mb-0 f-14">
                          {{ subCategory.label || 'No description available' }}
                        </p>
                      </div>
                    </div>
                    <div v-if="!loadingSubCategories && subCategories.length === 0" class="text-center text-muted py-3">
                      No subcategories available for this category
                    </div>
                  </div>
                </div>
              </div>
              <!-- Sms notification -->
              <!-- <div class="col-lg-4 col-lg-6 col-md-12 personal-detail">
                <p class="mb-1 info-title">Sms notification</p>
                <div class="mb-4 info-light">
                  get email to find what’s going on and what you are missing
                  when your are offline. You can turn the following on and off:
                </div>

                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Reminder</h3>
                    <p class="text-muted mb-0 f-14">
                      Receive reminders for upcoming bills.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Success Notification</h3>
                    <p class="text-muted mb-0 f-14">
                      Get notified when a payment is successful.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">General Announcements</h3>
                    <p class="text-muted mb-0 f-14">
                      Stay updated with news and announcements.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Information Updates</h3>
                    <p class="text-muted mb-0 f-14">
                      Updates about your account information.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Updates</h3>
                    <p class="text-muted mb-0 f-14">
                      Changes to your billing method or accounts.
                    </p>
                  </div>
                </div>
              </div> -->

              <!-- Push notification -->
              <!-- <div class="col-lg-4 col-lg-6 col-md-12 personal-detail-rg">
                <p class="mb-1 info-title">Push notification</p>
                <div class="mb-4 info-light">
                  get email to find what’s going on and what you are missing
                  when your are offline. You can turn the following on and off:
                </div>

                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Reminder</h3>
                    <p class="text-muted mb-0 f-14">
                      Receive reminders for upcoming bills.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Success Notification</h3>
                    <p class="text-muted mb-0 f-14">
                      Get notified when a payment is successful.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">General Announcements</h3>
                    <p class="text-muted mb-0 f-14">
                      Stay updated with news and announcements.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Information Updates</h3>
                    <p class="text-muted mb-0 f-14">
                      Updates about your account information.
                    </p>
                  </div>
                </div>
                <div class="d-flex gap-3 mb-3">
                  <div class="form-check form-switch m-0 p-0">
                    <label class="switch">
                      <input type="checkbox" checked />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div>
                    <h3 class="h6 mb-1">Billing Updates</h3>
                    <p class="text-muted mb-0 f-14">
                      Changes to your billing method or accounts.
                    </p>
                  </div>
                </div>
              </div> --> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "Setting",
  data() {
    return {
      categories: [],
      subCategories: [],
      selectedCategoryId: '',
      selectedCategory: null,
      loadingSubCategories: false,
      loadingCategories: false,
      updatingCategoryStatus: false,
      updatingSubCategoryStatus: false,
      userEmail: '',
      unsubscribedCategories: [],
      unsubscribedSubCategories: []
    };
  },
  async mounted() {
    this.userEmail = this.getUserEmail();
    await this.fetchCategories();
  },
  methods: {
    getUserEmail() {
      return this.$store.getters.memberEmail || '';
    },

    async fetchCategories() {
      this.loadingCategories = true;
      try {
        const response = await axios.get(`/message-center/categories`);
        if (response.data && response.data.data && response.data.data.data) {
          this.categories = response.data.data.data.map(category => ({
            ...category,
            enabled: true
          }));
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
        this.$notify("Failed to load categories", "error");
      } finally {
        this.loadingCategories = false;
      }
    },

    async fetchSubCategories(categoryId) {
      this.loadingSubCategories = true;
      try {
        const response = await axios.get(`/message-center/categories/${categoryId}/email-configurations`);
        if (response.data && response.data.data && response.data.data.data) {
          const selectedEmailConfigs = (response.data.data.selected_email_configs || []).map(id => parseInt(id));
          this.unsubscribedSubCategories = selectedEmailConfigs;
          this.subCategories = response.data.data.data.map(subCategory => ({
            ...subCategory,
            enabled: !selectedEmailConfigs.includes(parseInt(subCategory.id))
          }));
          this.updateMainCategoryToggle();
        }
      } catch (error) {
        console.error('Error fetching sub-categories:', error);
        this.$notify("Failed to load sub-categories", "error");
        this.subCategories = [];
      } finally {
        this.loadingSubCategories = false;
      }
    },
    updateMainCategoryToggle() {
      if (this.selectedCategory && this.subCategories.length > 0) {
        // Main category should be ON if at least one subcategory is ON
        const hasEnabledSubCategory = this.subCategories.some(sub => sub.enabled);
        this.selectedCategory.enabled = hasEnabledSubCategory;
        
        // Update the category in the main categories array
        const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
        if (categoryIndex !== -1) {
          this.categories[categoryIndex].enabled = hasEnabledSubCategory;
        }
      }
    },

    async onCategoryChange() {
      if (this.selectedCategoryId) {
        this.selectedCategory = this.categories.find(cat => cat.id == this.selectedCategoryId);
        await this.fetchSubCategories(this.selectedCategoryId);
      } else {
        this.selectedCategory = null;
        this.subCategories = [];
      }
    },

    async updateCategoryStatus() {
      if (!this.selectedCategory || !this.userEmail) {
        this.$notify("Missing required information", "error");
        return;
      }

      this.updatingCategoryStatus = true;

      try {
        if (this.selectedCategory.enabled) {
          await this.subscribeToCategoryNotifications();
          this.unsubscribedCategories = this.unsubscribedCategories.filter(id => id !== this.selectedCategory.id);
          const currentSubCategoryIds = this.subCategories.map(sub => sub.id);
          this.unsubscribedSubCategories = this.unsubscribedSubCategories.filter(id => 
            !currentSubCategoryIds.includes(id)
          );
          
          // Enable all subcategories
          this.subCategories = this.subCategories.map(subCategory => ({
            ...subCategory,
            enabled: true
          }));
        } else {
          if (!this.unsubscribedCategories.includes(this.selectedCategory.id)) {
            this.unsubscribedCategories.push(this.selectedCategory.id);
          }
          this.subCategories.forEach(subCategory => {
            if (!this.unsubscribedSubCategories.includes(subCategory.id)) {
              this.unsubscribedSubCategories.push(subCategory.id);
            }
          });
          this.subCategories = this.subCategories.map(subCategory => ({
            ...subCategory,
            enabled: false
          }));
          await this.unsubscribeFromCategoryNotifications(...this.subCategories.map(sub => sub.id));
        }

        const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
        if (categoryIndex !== -1) {
          this.categories[categoryIndex].enabled = this.selectedCategory.enabled;
        }

        this.$notify(
          `Successfully ${this.selectedCategory.enabled ? 'enabled' : 'disabled'} notifications for ${this.selectedCategory.name}`,
          "success"
        );
      } catch (error) {
        this.$notify("Failed to update category status", "error");
        this.selectedCategory.enabled = !this.selectedCategory.enabled;
      } finally {
        this.updatingCategoryStatus = false;
      }
    },

    async updateSubCategoryStatus(subCategory) {
      if (!this.selectedCategory || !this.userEmail) {
        this.$notify("Missing required information", "error");
        return;
      }

      this.updatingSubCategoryStatus = true;

      const subCategoryName = subCategory.name || subCategory.title || subCategory.label || `Subcategory (ID: ${subCategory.id})`;

      try {
        if (subCategory.enabled) {
          await this.subscribeToSubCategoryNotifications(subCategory);
          this.unsubscribedSubCategories = this.unsubscribedSubCategories.filter(id => id !== subCategory.id);
          
          if (!this.selectedCategory.enabled) {
            this.selectedCategory.enabled = true;
            const categoryIndex = this.categories.findIndex(cat => cat.id === this.selectedCategory.id);
            if (categoryIndex !== -1) {
              this.categories[categoryIndex].enabled = true;
            }
            this.unsubscribedCategories = this.unsubscribedCategories.filter(id => id !== this.selectedCategory.id);
          }
          
          this.$notify(
            `Successfully enabled notifications for ${subCategoryName}`,
            "success"
          );
        } else {
          await this.unsubscribeFromSubCategoryNotifications(subCategory);
          if (!this.unsubscribedSubCategories.includes(subCategory.id)) {
            this.unsubscribedSubCategories.push(subCategory.id);
        }
          
          this.updateMainCategoryToggle();
          
        this.$notify(
          `Successfully disabled notifications for ${subCategoryName}`,
          "success"
        );
        }
      } catch (error) {
        this.$notify(`Failed to update notifications for "${subCategoryName}"`, "error");
        subCategory.enabled = !subCategory.enabled;
      } finally {
        this.updatingSubCategoryStatus = false;
      }
    },

    async subscribeToCategoryNotifications() {
      const payload = {
        status: 0,
        email: this.userEmail,
        categories_id: this.selectedCategory.id.toString(),
        sub_categories_id: []
      };

      const response = await axios.post(`/message-center/update-subscription`, payload);

      if (!response.data || response.data.status !== 'success') {
        throw new Error('Failed to subscribe to notifications');
      }
    },

    async unsubscribeFromCategoryNotifications(...subCategoriesIds) {

      const payload = {
        email: this.userEmail,
        categories_id: this.selectedCategory.id.toString(),
        reason: "manually unsubscribed",
        description: "",
        sub_categories_id: subCategoriesIds
      };

      const response = await axios.post(`/message-center/unsubscribe-user`, payload);

      if (!response.data || response.data.status !== 'success') {
        throw new Error('Failed to unsubscribe from notifications');
      }
    },

    async subscribeToSubCategoryNotifications(subCategory) {
      const currentUnsubscribedSubCategoryIds = this.subCategories
        .filter(sub => !sub.enabled)
        .map(sub => sub.id.toString());

      const payload = {
        status: 0,
        email: this.userEmail,
        categories_id: this.selectedCategory.id.toString(),
        sub_categories_id: currentUnsubscribedSubCategoryIds
      };

      const response = await axios.post(`/message-center/update-subscription`, payload);

      if (!response.data || response.data.status !== 'success') {
        throw new Error('Failed to subscribe to subcategory notifications');
      }
    },

    async unsubscribeFromSubCategoryNotifications(subCategory) {
      const currentUnsubscribedSubCategoryIds = this.subCategories
        .filter(sub => !sub.enabled || sub.id === subCategory.id)
        .map(sub => sub.id.toString());

      const payload = {
        email: this.userEmail,
        categories_id: this.selectedCategory.id.toString(),
        reason: "manually unsubscribed",
        description: "",
        sub_categories_id: currentUnsubscribedSubCategoryIds
      };

      const response = await axios.post(`/message-center/unsubscribe-user`, payload);

      if (!response.data || response.data.status !== 'success') {
        throw new Error('Failed to unsubscribe from subcategory notifications');
      }
    }
  }
};
</script>

<style src="@/assets/css/setting.css"></style>

<style scoped>
.setting-wrapper {
  padding: 32px;
  background-color: #f3f6f8;
  margin-left: 200px;
  margin-top: 73px;
  max-width: calc(100% - 200px);
  min-height: 65vh;
}
.category-filter {
  border: 1px solid #eaeaea;
  background: #fbfbfb;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}
.category-list {
  max-height: 260px;
  overflow-y: scroll;
}
.text-muted {
  font-weight: 300;
}
.f-14 {
  font-size: 14px;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.1em;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.form-check input[type="checkbox"]:disabled + .slider {
  opacity: 0.6;
  cursor: not-allowed;
}
.form-check input[type="checkbox"]:disabled + .slider:hover {
  cursor: not-allowed;
}
.form-check input[type="checkbox"]:not(:disabled) + .slider:hover {
  opacity: 0.8;
}
.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}
@media (max-width: 768px) {
  .setting-wrapper {
    margin-left: 0;
    max-width: 100%;
    padding: 16px;
  }
  .setting-container {
    flex-direction: column;
  }
  .category-filter {
    padding: 1rem;
  }
}
</style>